import { StringField } from "../../../types/types";
import {
  TextDropdownModuleFields,
  TextDropdownModuleProps,
  TextDropdownModule,
} from "../types/TextDropdown.types";

export class TextDropdownModuleModel {
  private readonly fields?: TextDropdownModuleFields;

  constructor(props: TextDropdownModuleProps) {
    this.fields = props.fields;
  }

  get textValueList(): StringField {
    return this.fields?.textValueList
  }

  get title(): StringField | undefined {
    return this.fields?.Title
  }

  get anchorID(): StringField | undefined {
    return this.fields?.AnchorID
  }

  get primaryText(): StringField | undefined {
    return this.fields?.PrimaryText
  }

  get secondaryText(): StringField | undefined {
    return this.fields?.SecondaryText
  }

  get learnMoreAbout(): StringField | undefined {
    return this.fields?.LearnMoreAbout
  }

  get placeholderLabel(): StringField | undefined {
    return this.fields?.placeholderLabel
  }
}
